import React, {useState, useEffect } from "react";
import Loader from "react-loader-spinner";

const webview_loadder = () => {



        return (
            // bar
           // <Loader type="Bars" color="#00BFFF" height={80} width={80} />

             // Three docs
             <div className="container-fluid" style={{paddingTop:'55%'}}>
             <loaddercontainer style={{textAlign: 'center',paddingTop:'50%'}}>
                  <Loader type="ThreeDots" color="#4f4958" height={80} width={80} />
             </loaddercontainer>
            </div>


        //   <Loader
        //     type="Puff"
        //     color="#00BFFF"
        //     height={100}
        //     width={100}
        //     timeout={3000} //3 secs
        //   />
        );
}

export default webview_loadder